import { useEffect, useState, useRef } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Player } from "@lottiefiles/react-lottie-player";
import { useSocket } from "./SocketContext";

export default function RareAuraTicker({ t }) {
  const [queue, setQueue] = useState([]);
  const [currentMessage, setCurrentMessage] = useState(null);
  const timeoutRef = useRef(null);
  const { on, off } = useSocket();

  useEffect(() => {
    const handleRareAura = (data) => {
      const { id, firstName, auraName, probability } = data;
      const message = (
        <>
          <div style={styles.text}>
            {id + " " + firstName + " " + t("recieved")}
          </div>
          <div style={styles.auraText}>
            {t(auraName) + " " + "1/" + probability}
          </div>
        </>
      );
      setQueue((prevQueue) => [...prevQueue, message]);
    };

    const handleFriendOnline = (data) => {
      const { id, firstName } = data;
      console.log(data);
      const message = (
        <div style={styles.text}>
          {t("Your friend")} 👤 {firstName || id} {t("is online")}
        </div>
      );
      setQueue((prevQueue) => [...prevQueue, message]);
    };

    // Добавляем обработку события для друга, который выходит из игры
    const handleFriendOffline = (data) => {
      console.log(data, "Друг вышел");
      const { id, firstName } = data;
      const message = (
        <div style={styles.text}>
          {t("Your friend")} 👤 {firstName || id} {t("has gone offline")}
        </div>
      );
      setQueue((prevQueue) => [...prevQueue, message]);
    };

    on("rareAuraAnnounce", handleRareAura);
    on("friendOnline", handleFriendOnline);
    on("friendOffline", handleFriendOffline); // Слушаем событие friendOffline

    return () => {
      off("rareAuraAnnounce", handleRareAura);
      off("friendOnline", handleFriendOnline);
      off("friendOffline", handleFriendOffline); // Очищаем обработчик при размонтировании
      clearTimeout(timeoutRef.current);
    };
  }, []);

  useEffect(() => {
    if (!currentMessage && queue.length > 0) {
      const nextMessage = queue[0];
      setCurrentMessage(nextMessage);

      setQueue((prev) => prev.slice(1));

      timeoutRef.current = setTimeout(() => {
        setCurrentMessage(null);
      }, 17000);
    }
  }, [currentMessage, queue]);

  return (
    <AnimatePresence>
      {currentMessage && (
        <motion.div
          key={currentMessage}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.5 }}
          style={styles.wrapper}
        >
          <div style={styles.eye}>
            <Player
              autoplay
              src="eye.json"
              style={{
                height: "50px",
              }}
            ></Player>
          </div>

          <div style={styles.marquee}>{currentMessage}</div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}

const styles = {
  wrapper: {
    width: "100%",
    overflow: "hidden",
    zIndex: 1000,
    pointerEvents: "none",
    backgroundColor: "rgb(0, 0, 0)",
    padding: "4px 0",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "3vh",
    minHeight: 30,
    borderRadius: 20,
  },
  marquee: {
    display: "flex",
    whiteSpace: "nowrap",
    animation: "marquee 17.5s linear infinite",
    width: "100%",
    gap: 5,
  },
  text: {
    fontSize: "14px",
    fontWeight: "bold",
    color: "rgb(170, 170, 170)",
  },
  auraText: {
    fontSize: "14px",
    fontWeight: "bold",
    color: "#FFD700",
  },
  eye: {
    position: "absolute",
    display: "flex",
    justifyContent: "center",
    width: "100%",
  },
};
